<template>
  <div>
    <template v-if="keys != 3">
      <a :href="show(keys, month)">{{linked}}</a>
      <br>
    </template>
    <template v-else-if="keys == 3">
      <span @click="modal_call = true" class="hrefIS">
       {{persentase}}
      </span>
    </template>
    <template v-if="modal_call">
      <b-modal title="Persentase call answer by helpdesk" class="modal-info" size="sm" v-model="modal_call"
               @ok="modal_call = false">
        <div align="center" style="font-size: 20px;">
          ANSWER : <a :href="show(1, month)">{{answer}}</a>
          <br>
          CAll :  <a :href="show(0, month)">{{call}}</a>
          <br>
          Persentase : {{persentase}}
        </div>
      </b-modal>
    </template>


  </div>
</template>
<script>
  import moment from 'moment'
  export default{
    data() {
      return {
        modal_call: false,
        call: 0,
        answer: 0,
        persentase: ''
      }
    },
    created: function () {
      if(this.dataCall.length > 0) {
        this.call = this.dataCall[0].month[this.month]
        this.answer = this.dataCall[1].month[this.month]
        this.persentase = this.dataCall[3].month[this.month]
      }
    },
    props:{
      linked: {
        type: String,
        default: ''
      },
      keys: {
        type: Number,
        default: 0
      },
      month: {
        type: Number,
        default: 0
      },
      dataCall: {
        type: Array,
        default: function() { return []}
      }
    },
    methods: {
      show(key, indeks) {
        indeks++
        let performance_key, month, year
        performance_key =  key == 0 ? 7 :
          key == 1 ?  2 :
            key == 2 ?  8 : 15
        month = indeks <= 9 ? '0' + indeks : indeks
        year = moment().format('YYYY')
        month = year +  '-' + month
        return '#/helpdesk/kpi/detail?create=' + month +
          '&key=' + performance_key +
          '&type=2'
      }
    }
  }
</script>
<style scoped>
  .hrefIS{
    color: #20a8d8;
    cursor: pointer;
  }

  .hrefIS:hover{
    color: #167495;
    text-decoration: underline;
  }
</style>
